import { useEffect, useState } from "react";
import { MenuItem, Select } from "@mui/material";

export default function TableSelectField({
  header,
  cell,
  updatedValue,
  disabled = false,
  isQC = false,
}: any) {
  const [value, setValue] = useState<string | null>(null);

  useEffect(() => {
    if (cell) {
      if (isQC) {
        setValue(
          cell?.answers?.qc
            ? cell?.answers?.qc?.answer
            : cell?.answers?.inspector?.answer
        );
      } else {
        setValue(cell?.answers?.inspector?.answer);
      }
    }
  }, [cell]); // eslint-disable-line

  const onSingleSelectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setValue(value);
    if (updatedValue) {
      updatedValue(value, cell?.id);
    }
  };

  return (
    <Select
      sx={{ width: "100%", height: 40, padding: 1, my: 0.75 }}
      value={value || ""}
      onChange={(e: any) => onSingleSelectChange(e)}
      disabled={disabled}
    >
      <MenuItem value="">
        <em style={{ color: "#00000099" }}>Select an option</em>
      </MenuItem>
      {header?.answerOptions.map((opt: string) => (
        <MenuItem key={opt} value={opt}>
          {opt}
        </MenuItem>
      ))}
    </Select>
  );
}
